import React, { useState } from "react";
// import logn from ""
import Slider from "react-slick";
import slide1 from "../../assets/imgs/slide-1.webp";
import slide2 from "../../assets/imgs/slide-2.webp";
import slide3 from "../../assets/imgs/slide-3.webp";
import leaf1 from "../../assets/imgs/slider-leaf-1.webp";
import leaf2 from "../../assets/imgs/slider-leaf-2.webp";
import sicon1 from "../../assets/imgs/s-icon-1.webp";
import sicon2 from "../../assets/imgs/s-icon-2.webp";
import sicon3 from "../../assets/imgs/s-icon-3.webp";
import sicon4 from "../../assets/imgs/s-icon-4.webp";
import sicon5 from "../../assets/imgs/s-icon-5.webp";
import Modal from "react-bootstrap/Modal";
import Fcontact from "../Shared/Fcontact";
import "./css/slider.css";

const BannerSlider = () => {
  const [show, setShow] = useState(false);
  const [policy, setPolicy] = useState(false);

  const handleClose = () => {
    setPolicy(false);
    setShow(false);
  };
  const handleShow = () => {
    setPolicy(true);
    setShow(true);
  };

  const AboutFunction = (eleme) => {
    const violation = document.getElementById(eleme);
    window.scrollTo({
      top: violation.offsetTop,
      behavior: "smooth",
    });
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <header id="home_section">
        <div className="container-fluid">
          <div className="banner-wrap">
            <div className="banner-slider">
              <Slider {...settings}>
                <div className="banner-slide">
                  <div className="container">
                    <div className="sliderContent">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="slideTxt">
                            <div
                              className="darkTxt"
                              data-animation="fadeInUp"
                              data-delay="0.16s"
                            >
                              <h1>
                                A Cloud-based <br />
                                charity-focused{" "}
                                <span
                                  className="blueTxt"
                                  data-animation="fadeInUp"
                                  data-delay="0.8s"
                                >
                                  Nonprofit Software.
                                </span>
                              </h1>
                            </div>
                            <p data-animation="fadeIn" data-delay="1s">
                              A comprehensive fundraising software solution to
                              help you transform your operations.
                            </p>
                            <div className="homesliderbtn">
                              {" "}
                              <a
                                className="rc-primary-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                aria-label="Get a Demo Button"
                                onClick={handleShow}
                              >
                                Get a Demo <i className="icon-arrow"></i>
                              </a>{" "}
                              <a
                                onClick={() => AboutFunction("getStrated")}
                                className="rc-secondry-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                aria-label="Free Trial Button"
                              >
                                Free Trial <i className="icon-arrow"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="scl-cc"
                            data-animation="zoomIn"
                            data-delay="1s"
                          >
                            <div className="sliderLeafTop">
                              <img
                                src={leaf1}
                                alt="Nonprofits"
                                width="233"
                                height="145"
                              />
                            </div>
                            <div className="sliderLeafbottom">
                              <img
                                src={leaf2}
                                alt="Volunteer Management"
                                width="140"
                                height="245"
                              />
                            </div>
                            <div className="mask">
                              <img
                                src={slide1}
                                alt="Nonprofit CRM Software"
                                width="1000"
                                height="667"
                              />
                            </div>

                            <div className="sliderIcon-1">
                              <img src={sicon1} alt="Nonprofit Solution" />
                            </div>
                            <div className="sliderIcon-2">
                              <img src={sicon2} alt="Fundraising" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-slide">
                  <div className="container">
                    <div className="sliderContent">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="slideTxt">
                            <div
                              className="darkTxt"
                              data-animation="fadeInUp"
                              data-delay="0.16s"
                            >
                              A Suitable for <br />
                              Societies, Churches,
                            </div>
                            <div
                              className="blueTxt"
                              data-animation="fadeInUp"
                              data-delay="0.8s"
                            >
                              and Associations.
                            </div>
                            <p data-animation="fadeIn" data-delay="1s">
                              Manage your congregation's information and in-kind
                              donations with a nonprofit CRM software.{" "}
                            </p>
                            <div className="homesliderbtn">
                              {" "}
                              <a
                                className="rc-primary-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                aria-label="Get a Demo Button"
                                onClick={handleShow}
                              >
                                Get a Demo <i className="icon-arrow"></i>
                              </a>{" "}
                              <a
                                onClick={() => AboutFunction("getStrated")}
                                className="rc-secondry-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                aria-label="Free Trial Button"
                              >
                                Free Trial <i className="icon-arrow"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="scl-cc"
                            data-animation="zoomIn"
                            data-delay="1s"
                          >
                            <div className="sliderLeafTop">
                              <img src={leaf1} alt="Nonprofits" />{" "}
                            </div>
                            <div className="sliderLeafbottom">
                              <img src={leaf2} alt="Volunteer Management" />
                            </div>
                            <div className="mask">
                              <img
                                src={slide2}
                                alt="fundraising software for nonprofits"
                                width="1000"
                                height="667"
                              />
                            </div>

                            <div className="sliderIcon-1">
                              <img src={sicon3} alt="Donor Management" />
                            </div>
                            <div className="sliderIcon-2">
                              <img src={sicon4} alt="Church CRM" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-slide">
                  <div className="container">
                    <div className="sliderContent">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="slideTxt">
                            <div
                              className="darkTxt"
                              data-animation="fadeInUp"
                              data-delay="0.16s"
                            >
                              Powerful features <br />
                              for better collaboration
                            </div>
                            <div
                              className="blueTxt"
                              data-animation="fadeInUp"
                              data-delay="0.8s"
                            >
                              and stewardship.
                            </div>
                            <p data-animation="fadeIn" data-delay="1s">
                              Create acknowledgment templates, include appeals
                              and connect with Grantmakers and
                              Beneficiaries.{" "}
                            </p>
                            <div className="homesliderbtn">
                              {" "}
                              <a
                                className="rc-primary-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                onClick={handleShow}
                                aria-label="Get a Demo Button"
                              >
                                Get a Demo <i className="icon-arrow"></i>
                              </a>{" "}
                              <a
                                onClick={() => AboutFunction("getStrated")}
                                className="rc-secondry-btn rc-large-btn rc-btn"
                                tabIndex="0"
                                aria-label="Free Trial Button"
                              >
                                Free Trial <i className="icon-arrow"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="scl-cc"
                            data-animation="zoomIn"
                            data-delay="1s"
                          >
                            <div className="sliderLeafTop">
                              <img src={leaf1} alt="Nonprofits" />{" "}
                            </div>
                            <div className="sliderLeafbottom">
                              <img src={leaf2} alt="Volunteer Management" />
                            </div>
                            <div className="mask">
                              <img
                                src={slide3}
                                alt="nonprofit programs"
                                width="1000"
                                height="667"
                              />
                            </div>

                            <div className="sliderIcon-1">
                              <img src={sicon4} alt="Powerful features" />
                            </div>
                            <div className="sliderIcon-2">
                              <img src={sicon5} alt="Stewardship" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
          <div className="downScrollarrow">
            <a href="#about_us" aria-label="Page scroll down">
              <img
                width="29"
                height="37"
                src={require("../../assets/imgs/downArrow.webp")}
                alt="scroll down"
              />
            </a>
          </div>
        </div>
      </header>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton></Modal.Header>
        <Fcontact policy={policy} />
      </Modal>
    </>
  );
};

export default BannerSlider;
